module.exports = __webpack_public_path__ + "img/sec3_coin.c89593bd.png";